// extracted by mini-css-extract-plugin
module.exports = {"width-160":"_2UkYpR04pY","width-430":"x9F-fX5uAM","remark":"_3jHpnVBgVK","reminder-block":"_36m2zKLKcZ","text-button":"_9lmOsPQmkn"};